const doc = [({"da":({"js":({"organizations":({"select":({"choose_organization":"Vælg organisation"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;